import { render, staticRenderFns } from "./PhdReview.vue?vue&type=template&id=11125db2&scoped=true&"
import script from "./PhdReview.vue?vue&type=script&lang=js&"
export * from "./PhdReview.vue?vue&type=script&lang=js&"
import style0 from "./PhdReview.vue?vue&type=style&index=0&id=11125db2&prod&lang=css&"
import style1 from "./PhdReview.vue?vue&type=style&index=1&id=11125db2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11125db2",
  null
  
)

export default component.exports